import React, { useMemo } from "react";
import { Box, MenuItem, Paper, Select, TextField } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Query, queryOps } from "system/query/Query";
import { QueryInfo } from "system/query/QueryInfo";
import QuerySegmentOptionsDialog from "components/queries/queryBuilder/dialogParts/QuerySegmentOptionsDialog";
import { SimpleFormLabel } from "components/dialogs/SimpleFormDialog";
import { QuerySegment } from "system/query/QuerySegment";
import { QueryBranch } from "system/query/QueryBranch";

export interface QueryBranchBuilderDialogProps {
  isOpen: boolean;
  setDialogIsOpen: Function;
  parent?: QuerySegment | Query;
  queryBranch: QueryBranch;
  queryInfo: QueryInfo;
  updateQuery: Function;
  originalQuery: Query;
}

export function QueryBranchBuilderDialog(props: QueryBranchBuilderDialogProps): JSX.Element {
  const {i18n} = useTranslation();

  const [operator, setOperator] = useState<string>(props.queryBranch.op);
  const [quorum, setQuorum] = useState<number | undefined>(props.queryBranch.quorum);

  const isQuorumable = operator === queryOps.or || operator === queryOps.not;

  const showConfirmation = useMemo(() => {
    return operator !== props.queryBranch.op || quorum !== props.queryBranch.quorum;
  }, [operator, quorum, props.queryBranch.op, props.queryBranch.quorum]);

  return (
    <QuerySegmentOptionsDialog
      isOpen={props.isOpen}
      parent={props.parent}
      querySegment={props.queryBranch}
      updateQuery={props.updateQuery}
      originalQuery={props.originalQuery}
      showCancelConfirmation={showConfirmation}
      onCancel={(event: any) => {
        event.stopPropagation();
        props.setDialogIsOpen(false)
      }}
      onConfirm={(event: any) => {
        event.stopPropagation();
        props.queryBranch.op = operator as queryOps;
        if (isQuorumable && quorum && quorum > 1) {
          props.queryBranch.quorum = quorum;
        } else {
          delete props.queryBranch.quorum;
        }
        props.updateQuery(props.originalQuery);
        props.setDialogIsOpen(false)
      }}
      title={i18n.t("query-form.branch-dialog-title")}
      >
      <Paper sx={{ p: 2, pt: 0.5 }}>
        <SimpleFormLabel>{i18n.t("query-form.operator")}</SimpleFormLabel>
        <Select
          value={operator}
          label={i18n.t("query-form.operator")}
          onChange={(event: any) => setOperator(event.target.value)}>
          <MenuItem value={queryOps.and}>{i18n.t("query-form.and")}</MenuItem>
          <MenuItem value={queryOps.or}>{i18n.t("query-form.or")}</MenuItem>
          <MenuItem value={queryOps.not}>{i18n.t("query-form.not")}</MenuItem>
        </Select>
        {isQuorumable &&
          <Box>
            <SimpleFormLabel>{i18n.t("query-form.quorum")}</SimpleFormLabel>
            <TextField
              autoComplete="off"
              type="number"
              value={quorum || 1}
              onChange={(event: any) => setQuorum(event.target.value)} />
          </Box>
        }
      </Paper>
    </QuerySegmentOptionsDialog>
  );
};
